import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card } from "@/components/ui/card";
import { TrendingUp, Target, Trophy, AlarmClock } from "lucide-react";
import { API } from "@/lib/api";
import { useOrgCurrency } from "@/lib/currency-context";

const STAGE_LABELS = { neu: "Neu", angebot: "Angebot", verhandlung: "Verhandlung", gewonnen: "Gewonnen", verloren: "Verloren" };
export function CRMStatsPanel() {
  const { formatMoney } = useOrgCurrency();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    axios.get(`${API}/crm/stats`)
      .then((r) => setStats(r.data))
      .catch((e) => setError(e?.response?.data?.detail || "Statistik konnte nicht geladen werden"));
  }, []);
  if (error) return <p className="text-sm text-[var(--brand-muted)]" data-testid="crm-stats-error">{error}</p>;
  if (!stats) return <p className="text-sm text-[var(--brand-muted)]">Lädt …</p>;
  const maxVal = Math.max(1, ...stats.stages.map((s) => s.value));
  const kpis = [
    { icon: TrendingUp, label: "Offene Pipeline", value: formatMoney(stats.open_value), sub: `${stats.open_count} offene Deals`, testId: "crm-stat-open" },
    { icon: Target, label: "Gewichtete Pipeline", value: formatMoney(stats.weighted_pipeline), sub: "nach Wahrscheinlichkeit", testId: "crm-stat-weighted" },
    { icon: Trophy, label: "Win-Rate", value: stats.win_rate != null ? `${stats.win_rate} %` : "–", sub: `${formatMoney(stats.won_value)} gewonnen`, testId: "crm-stat-winrate" },
    { icon: AlarmClock, label: "Fällige Aufgaben", value: stats.overdue_tasks, sub: "heute oder überfällig", testId: "crm-stat-overdue" },
  ];
  return (
    <div data-testid="crm-stats-panel">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {kpis.map((k) => (
          <Card key={k.label} className="p-4 bg-white border-[var(--brand-border)]" data-testid={k.testId}>
            <div className="flex items-center gap-2 text-xs text-[var(--brand-muted)] mb-1"><k.icon className="w-3.5 h-3.5 text-[var(--brand-primary)]" /> {k.label}</div>
            <div className="text-2xl font-bold text-[var(--brand-ink)]">{k.value}</div>
            <div className="text-[11px] text-[var(--brand-muted)]">{k.sub}</div>
          </Card>
        ))}
      </div>
      <Card className="p-5 bg-white border-[var(--brand-border)]" data-testid="crm-stats-stages">
        <h3 className="text-sm font-semibold text-[var(--brand-ink)] mb-3">Pipeline nach Phase</h3>
        <div className="space-y-2.5">
          {stats.stages.map((s) => (
            <div key={s.stage} className="flex items-center gap-3" data-testid={`crm-stage-row-${s.stage}`}>
              <span className="w-28 text-sm text-[var(--brand-ink)]">{STAGE_LABELS[s.stage] || s.stage}</span>
              <div className="flex-1 h-5 bg-[var(--brand-border-light)] rounded-full overflow-hidden">
                <div className={`h-full rounded-full ${s.stage === "gewonnen" ? "bg-green-500" : s.stage === "verloren" ? "bg-red-400" : "bg-[var(--brand-primary)]"}`}
                  style={{ width: `${Math.round((s.value / maxVal) * 100)}%`, minWidth: s.count ? "6px" : 0 }} />
              </div>
              <span className="w-36 text-right text-xs text-[var(--brand-muted)]">{s.count} · {formatMoney(s.value)}</span>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-[var(--brand-muted)] mt-4">
          Premium-Automation aktiv: Bei fälligen Deal-Aufgaben bekommst du automatisch eine Erinnerung (Glocke + E-Mail).
        </p>
      </Card>
    </div>
  );
}
